import React, { Component } from 'react';
import { Row, Col, Steps, Spin, Button, message, Input, Select, DatePicker } from 'antd';
import { connect } from 'react-redux';
import country from './../../countries';
import moment from 'moment';
import $ from 'jquery';

import { upload_files, save_onboard } from './actions/onboarding.action';

import './style.css';
import { times } from 'underscore';

const { Step } = Steps;
const Option = Select.Option
const { TextArea } = Input;
const dateFormat = 'YYYY/MM/DD';

const steps = [
    { title: 'First' },
    { title: 'Second' },
    { title: 'Last' }
];

class OnBoardLanding extends Component {

    constructor( props ) {

        super( props );

        this.state = {
            name: '',
            profile: 'data:image/png;base64,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',
            user_name: '',
            password: '', 
            mobile_number: '',
            country: '',
            states: '',
            date_of_birth: '',
            gender: '',
            marital_status: '',
            religion: '',
            mother: '',
            father: '',
            current_address: '',
            home_country_address: '',
            emergency_contact_person_ame_1: '',
            emergency_contact_person_ame_2: '',
            relationship_1: '',
            relationship_2: '',
            contact_number_1: '',
            contact_number_2: '',
            profile_pic: '',
            current: 0,
            loading: false,
            account_active: false,
        };

        this.handleSubmit = this.handleSubmit.bind( this );
        this.handleProfilePic = this.handleProfilePic.bind( this );

    }

    handleProfilePic( e ){

        var fdata = new FormData();
        var user_id =  this.props.match.params.id;
        this.setState({ loading: true });

        if( e.target.files.length>0 ){
            $.each( e.target.files, function( i, file ){

                if( file.size >= 524288000 ){
                    message.error( "File Size too Big", "error" );
                    return false;
                }
                
                fdata.append( "file"+[i], file );
                fdata.append( "user_id", user_id );

            });
        }

        this.props.upload_files( fdata );

    }

    handleSubmit(){ 

        var user_id =  this.props.match.params.id;
        var name =  this.props.match.params.name;

        let temp = {
            user_id: user_id,
            name: name,
            user_name: this.state.user_name,
            password: this.state.password, 
            mobile_number: this.state.mobile_number,
            country: this.state.country,
            states: this.state.states,
            date_of_birth: this.state.date_of_birth,
            gender: this.state.gender,
            marital_status: this.state.marital_status,
            religion: this.state.religion,
            mother: this.state.mother,
            father: this.state.father,
            current_address: this.state.current_address,
            home_country_address: this.state.home_country_address,
            emergency_contact_person_ame_1: this.state.emergency_contact_person_ame_1,
            emergency_contact_person_ame_2: this.state.emergency_contact_person_ame_2,
            relationship_1: this.state.relationship_1,
            relationship_2: this.state.relationship_2,
            contact_number_1: this.state.contact_number_1,
            contact_number_2: this.state.contact_number_2,
            profile_pic: this.state.profile_pic
        }

        if( this.state.user_name === '' ||
            this.state.password === '' || 
            this.state.mobile_number === '' ||
            this.state.country === '' ||
            this.state.states === '' ||
            this.state.date_of_birth === '' ||
            this.state.gender === '' ||
            this.state.marital_status === '' ||
            this.state.religion === '' ||
            this.state.mother === '' ||
            this.state.father === '' ||
            this.state.current_address === '' ||
            this.state.home_country_address === '' ||
            this.state.emergency_contact_person_ame_1 === '' ||
            this.state.emergency_contact_person_ame_2 === '' ||
            this.state.relationship_1 === '' ||
            this.state.relationship_2 === '' ||
            this.state.contact_number_1 === '' ||
            this.state.contact_number_2 === '' ){
            message.error( 'All fields are mandatory!' );
            return false;
        }

        if( this.state.profile_pic === '' ){
            message.error( 'Please upload profile picture!' );
            return false;
        }

        // Send to Server
        this.props.save_onboard( temp );

    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }
    
    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    componentWillMount(){
        let name = this.props.match.params.name;
        this.setState({ name });

    }

    componentWillReceiveProps( nextProps ){
        
        if( nextProps.onboard.length !== 0 ){

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "File Uploaded" ){
                this.setState({ 
                    profile_pic: nextProps.onboard.OUTPUT.DATA,
                    profile: nextProps.onboard.OUTPUT.DATA,
                    loading: false
                });

            }

            if( nextProps.onboard.STATUS.CODE === "400" ){
                message.error( nextProps.onboard.STATUS.MESSAGE );
                this.setState({ loading: false });
            }

            if( nextProps.onboard.STATUS.CODE === "200" &&
                nextProps.onboard.STATUS.MESSAGE === "Successfully Updated Onboarding" ){

                message.success( 'Your account has been successfully created.' );

                setTimeout( ()=> {
                    window.location.href = 'https://hrms.digitalventure1.com';
                }, 1000 );

            }  

        }

    }
    
    render() {

        const { current } = this.state;
        
        const country_list = country.countries.map( ( item, i ) => 
            <Option key={ item.country }>{ item.country }</Option> );

        const state_list = country.countries.map( ( item, i ) => {
            if( item.country === this.state.country ){

                return item.states.map( ( value, k ) => <Option key={ value }>{ value }</Option> )

            }
        });

        return (
            <Row>
                <Col span={24}>

                    <div className="wrapper-onboard">

                        <div className="headsection">
                            <img src="images/workarea.jpg" />
                        </div>

                        <div className="step_section">
                            <h1>Welcome aboard !!</h1>

                            <hr className="separator"/>

                            <div className="form_section">

                                <Steps size="small" current={ this.state.current }>
                                    <Step title="Account" />
                                    <Step title="Profile" />
                                    <Step title="You're all set" />
                                </Steps>

                                <div className="steps-content">

                                    <Spin spinning={this.state.loading}>

                                    { (this.state.current === 0 ) ? <div>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={24}>
                                                <label>Candidate Name</label>
                                                <Input style={{ width:'100%' }} value={ this.state.name } disabled />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>User Name</label>
                                                <Input style={{ width:'100%' }} 
                                                    onChange={ ( e ) => this.setState({ user_name: e.target.value }) }
                                                    autocomplete={ "new-password" }
                                                    value={ this.state.user_name } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Password</label>
                                                <Input style={{ width:'100%' }} type="password" 
                                                    onChange={ ( e ) => this.setState({ password: e.target.value }) }
                                                    autocomplete={ "new-password" }
                                                    value={ this.state.password } />
                                            </Col>
                                        </Row>
                                        
                                    </div> : (this.state.current === 1 ) ? <div>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Mobile Number</label>
                                                <Input style={{ width:'100%' }} 
                                                    onChange={ ( e ) => this.setState({ mobile_number: e.target.value }) }
                                                    value={ this.state.mobile_number } />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Country</label>
                                                <Select 
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={ ( value ) => this.setState({ country: value }) }
                                                    value={ this.state.country }
                                                    style={{ width:'100%' }}>
                                                    { country_list }
                                                </Select>
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>State</label>
                                                <Select 
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={ ( value ) => this.setState({ states: value }) }
                                                    value={ this.state.states }
                                                    style={{ width:'100%' }}>
                                                    { state_list }
                                                </Select>
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Date Of Birth</label>
                                                <DatePicker style={{ width: '100%' }}
                                                    value={ moment( this.state.date_of_birth ,dateFormat ) }
                                                    onChange={ (date, dateString ) => this.setState({ date_of_birth: dateString }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Gender</label>
                                                <Select 
                                                    value={ this.state.gender }
                                                    onChange={ ( value ) => this.setState({ gender: value }) }
                                                    style={{ width:'100%' }}>
                                                    <Option value="male">Male</Option>
                                                    <Option value="female">Female</Option>
                                                    <Option value="other">Other</Option>
                                                </Select>
                                            </Col>
                                        </Row>


                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Marital Status</label>
                                                <Select 
                                                    value={ this.state.marital_status }
                                                    onChange={ ( value ) => this.setState({ marital_status: value }) }
                                                    style={{ width:'100%' }}>
                                                    <Option value="single">Single</Option>
                                                    <Option value="married">Married</Option>
                                                </Select>
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Religion</label>
                                                <Select 
                                                    showSearch
                                                    filterOption={(input, option) =>
                                                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    }
                                                    onChange={ ( value ) => this.setState({ religion: value }) }
                                                    value={ this.state.religion }
                                                    style={{ width:'100%' }}>
                                                    <Option value="christianity">Christianity</Option>
                                                    <Option value="islam">Islam</Option>
                                                    <Option value="hinduism">Hinduism</Option>
                                                    <Option value="buddhism">Buddhism</Option>
                                                    <Option value="sikhism">Sikhism</Option>
                                                    <Option value="judaism">Judaism</Option>
                                                    <Option value="spiritism">Spiritism</Option>
                                                    <Option value="bahai">Bahai</Option>
                                                    <Option value="jainism">Jainism</Option>
                                                    <Option value="shinto">Shinto</Option>
                                                    <Option value="zoroastrianism">Zoroastrianism</Option>
                                                    <Option value="tenrikyo">Tenrikyo</Option>
                                                    <Option value="neo-paganism">Neo-Paganism</Option>
                                                    <Option value="unitarian-universalism">Unitarian-Universalism</Option>
                                                    <Option value="nonreligious">Nonreligious (Secular/Agnostic/Atheist)</Option>
                                                </Select>
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Mother</label>
                                                <Input style={{ width:'100%' }} 
                                                    value={ this.state.mother }
                                                    onChange={ (e) => this.setState({ mother: e.target.value }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Father</label>
                                                <Input style={{ width:'100%' }} 
                                                    value={ this.state.father }
                                                    onChange={ (e) => this.setState({ father: e.target.value }) } />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Current Address</label>
                                                <TextArea rows={ 3 } style={{ width: '100%' }} 
                                                    value={ this.state.current_address }
                                                    onChange={ (e) => this.setState({ current_address: e.target.value }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Home Country Address</label>
                                                <TextArea rows={ 3 } style={{ width: '100%' }} 
                                                    value={ this.state.home_country_address }
                                                    onChange={ (e) => this.setState({ home_country_address: e.target.value }) } />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Emergency Contact Person Name #1</label>
                                                <Input style={{ width:'100%' }} placeholder="e.g. John Wick" 
                                                    value={ this.state.emergency_contact_person_ame_1 }
                                                    onChange={ ( e ) => this.setState({ emergency_contact_person_ame_1: e.target.value }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Emergency Contact Person Name #2</label>
                                                <Input style={{ width:'100%' }} 
                                                    value={ this.state.emergency_contact_person_ame_2 }
                                                    onChange={ ( e ) => this.setState({ emergency_contact_person_ame_2: e.target.value }) } />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Relationship #1</label>
                                                <Input style={{ width:'100%' }} placeholder="e.g. Husband" 
                                                    value={ this.state.relationship_1 }
                                                    onChange={ ( e ) => this.setState({ relationship_1: e.target.value }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Relationship #2</label>
                                                <Input style={{ width:'100%' }} 
                                                    value={ this.state.relationship_2 }
                                                    onChange={ ( e ) => this.setState({ relationship_2: e.target.value }) } />
                                            </Col>
                                        </Row>

                                        <Row gutter={16} style={{ marginBottom: '10px' }}>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Contact Number #1</label>
                                                <Input style={{ width:'100%' }} placeholder="e.g. +971 0 0000 0000" 
                                                    value={ this.state.contact_number_1 }
                                                    onChange={ ( e ) => this.setState({ contact_number_1: e.target.value }) } />
                                            </Col>
                                            <Col span={12}>
                                                <label><em className="required">*</em>Contact Number #2</label>
                                                <Input style={{ width:'100%' }} 
                                                    value={ this.state.contact_number_2 }
                                                    onChange={ ( e ) => this.setState({ contact_number_2: e.target.value }) } />
                                            </Col>
                                        </Row>

                                    </div> : <div>
                                        <Row>
                                            <Col span={24}>
                                                <div style={{ textAlign: 'center', height: '120px', margin: '30px 0' }}>
                                                    <img src={ this.state.profile } className="profile_pic"/>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24}>
                                                <input 
                                                    onChange={ this.handleProfilePic }
                                                    type="file" className="profile_upload" />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={24} style={{ textAlign: 'center' }}>
                                                <Button type="default" className="submit_onboard" onClick={ this.handleSubmit }>
                                                    Submit
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>  }
                                    </Spin>
                                </div>
                                
                                <div className="steps-action">
                                    {current < steps.length - 1 && (
                                        <Button type="primary" icon="arrow-right" 
                                            onClick={() => this.next()}>
                                            Next
                                        </Button>
                                    )}
                                    {current === steps.length - 1 && (
                                        <span>&nbsp;</span>
                                    )}
                                    {current > 0 && (
                                        <Button style={{ marginLeft: 8 }} icon="arrow-left" 
                                            onClick={() => this.prev()} className="fl_right">
                                            Previous
                                        </Button>
                                    )}
                                </div>

                            </div>

                        </div>

                    </div>

                </Col>

            </Row>

        )

    }

}

function mapStatetoProps( state ){
    return {
        onboard: state.onboard
    }
}

export default connect( mapStatetoProps, { upload_files, save_onboard })( OnBoardLanding );


// WEBPACK FOOTER //
// ./src/pages/onboarding/index.js